import { Routes, Router } from '@angular/router';

import { PhoneLayoutComponent, AuthLayoutComponent } from './core';
import { AuthGuardService } from '@wephone-core/service/auth_guard.service';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { MessageService, inIframe, Platform } from '@wephone-utils';
import { MissedCallsComponent } from '@wephone-common';
import { AgentPageComponent } from '@wephone-app-phone/pages/agent-page/agent-page.component';
import { CallLogListPage } from '@wephone-app-phone/pages/history/calllog-list/calllog-list';
import { EnterpriseContactsPage } from '@wephone-app-phone/pages/enterprise-contacts/enterprise-contacts';
import { AppConfigService } from 'src/app/wephone-common/service';
import { PhoneDashboardPage } from '@wephone-app-phone/pages/phone-dashboard/phone-dashboard.component';
import { WephoneSessionModule } from '@wephone-session/wephone-session.module'; // not remove
import { CallHistoryComponent } from './pages/call-history/call-history.component';
import { SmsinHandlerComponent } from '@wephone-sms/component';
import { MyvoicemailsComponent } from './pages/voicemails/myvoicemails/myvoicemails.component';
import { WsRpcService } from '@wephone-core/service/wsrpc_service';
// import { PhoneCall } from './services';
// import { VMReaderDataMsg } from '@wephone-core/model/repository/voicemail.i';
import { ConfigManager, FlexIvrSettings } from '@wephone-core/wephone-core.module';
import { OptionParam } from '@wephone-core/system';

export const AppRoutes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        component: PhoneLayoutComponent,
        resolve: {
          config: AppConfigService
        },
        children: [
          {
            path: 'dashboard',
            component: PhoneDashboardPage
          },
          {
            path: 'agent_page',
            component: AgentPageComponent
          },
          {
            path: 'enterprise-contacts',
            component: EnterpriseContactsPage
          },
          {
            path: 'phonevoicemailqueue',
            component: MyvoicemailsComponent
          },
          {
            path: 'sms-handler',
            component: SmsinHandlerComponent
          },
          {
            path: 'calllog',
            component: CallLogListPage
          },
          {
            path: 'mycalllog',
            component: CallHistoryComponent
          },
          {
            path: 'mymissedcall',
            component: MissedCallsComponent
          },
          {
            path: '',
            redirectTo: '/dashboard',
            pathMatch: 'full'
          },
        ]
      },
      // {
      //   path: '**',
      //   redirectTo: 's/404'
      // }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 's',
        loadChildren: () => import('../../../../src/app/wephone-session/wephone-session.module').then(m => m.WephoneSessionModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

@Injectable()
export class RoutingService {
  inBrowser: boolean;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly wsrpc: WsRpcService,
    private readonly messageService: MessageService,
    private readonly configService: ConfigManager,
    private readonly platform: Platform,
    private readonly settings: FlexIvrSettings,
  ) {
    this.inBrowser = this.platform.isDesktop() && !this.platform.isElectronApp();
    this.messageService.subscribe('application:login:success', returnUrl => {
      // Update flex-ivr settings
      this.settings.updateMaxUploadSize(this.configService.getOptionParamValue(OptionParam.max_upload_sizes, null));

      const userParams = this.configService.getUserParams();
      // if (inIframe()) {
      //   if (returnUrl) {
      //     this.router.navigateByUrl(returnUrl);
      //   }
      // } else {
      //   if (this.inBrowser && userParams.open_bo_on_call) {
      //     document.location.href = `/phone/container.html`;
      //     return;
      //   }

      //   if (returnUrl) {
      //     this.router.navigateByUrl(returnUrl);
      //   }
      // }

      if (!inIframe() && this.inBrowser && userParams.open_bo_on_call) {
        document.location.href = `/phone/container.html`;
        return;
      }

      this.router.navigateByUrl(returnUrl || this.authService.getDefaultReturnUrl());
    });

    this.messageService.subscribe('phone:missed_call', () => {
      const now: number = Date.now();
      // Open the missed-call tab, must add param t to refresh page callhistory if already in page but from another tab
      // console.log('redirect to missed-call page');
      this.router.navigateByUrl(`dashboard?view=callhistory&tab=missed_call&t=${now}`);
    });
  }

  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/s/signin']);

      return false;
    }

    return true;
  }
}
